import { useAuthSessionStore } from '@/store/authSessionStore'
import { applyAuthSessionTokens } from './applyAuthSessionTokens.js'

// On app boot, re-wire the axios access token + refresh handler from the
// persisted session (zustand persist restores the raw values, but not the axios
// side effects). Returns true when a session was restored.
export function rehydrateAuthSession() {
  const { user, accessToken, refreshToken, loginType } = useAuthSessionStore.getState()
  if (!accessToken || !user) return false
  applyAuthSessionTokens(user, accessToken, refreshToken || '', loginType || 'email')
  return true
}
